import { createBrowserRouter } from "react-router-dom";
import AuthPage from './auth';
import Admins from "./admins";
import AdminEdit from "./admins/edit";
import AdminAdd from "./admins/add";
import UsersStats from "./statistics/users";
import BuysForUsers from "./statistics/buys-for-users";


const router = createBrowserRouter([

  { path: "/",                element: <UsersStats />       },

  { path: "/auth",            element: <AuthPage />       },

  { path: "/admins",           element: <Admins/>           },
  { path: "/admins/add",       element: <AdminAdd/>        },
  { path: "/admins/:id",       element: <AdminEdit/>        },

  { path: "/statistics/users",       element: <UsersStats/>        },
  { path: "/statistics/buys-for-users",       element: <BuysForUsers/>        },
	
]);

export default router;